import { render } from "./ObjectViewer.vue?vue&type=template&id=45e4617e&scoped=true"
import script from "./ObjectViewer.vue?vue&type=script&lang=js"
export * from "./ObjectViewer.vue?vue&type=script&lang=js"

import "./ObjectViewer.vue?vue&type=style&index=0&id=45e4617e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45e4617e"]])

export default __exports__